module.exports = __webpack_public_path__ + "img/19.255654cd.jpg";